import { CHORD } from './chord';
import * as DECADES from './decades';
import { DIFFICULTY } from './difficulty';
import * as GENRES from './genres';
import { STRUM_PATTERN } from './strumPattern';
import LYRIC_LIST from '../lyrics';
import { SongType } from '../types';

const UG = 'https://tabs.ultimate-guitar.com/tab';

const CAPO_1 = 'Capo 1';
const CAPO_2 = 'Capo 2';
const CAPO_3 = 'Capo 3';
const CAPO_4 = 'Capo 4';
const CAPO_5 = 'Capo 5';
// const CAPO_6 = 'Capo 6';
const CAPO_7 = 'Capo 7';

export const SongList: SongType[] = [
	// - A -
	{
		title: 'A Horse With No Name',
		artist: 'America',
		chords: [CHORD.E_MINOR, CHORD.D_SIX_NINE],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.FOLK, GENRES.ROCK],
		link: `${UG}/america/a-horse-with-no-name-chords-1042336`,
		lyrics: LYRIC_LIST.AHorseWithNoName,
	},
	{
		title: 'American Pie',
		artist: 'Don McLean',
		chords: [
			CHORD.G,
			CHORD.D_OVER_F_SHARP,
			CHORD.E_MINOR,
			CHORD.A_MINOR,
			CHORD.C,
			CHORD.D,
		],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.FOLK, GENRES.ROCK],
		link: `${UG}/don-mclean/american-pie-chords-187946`,
		lyrics: LYRIC_LIST.AmericanPie,
	},
	// - B -
	{
		title: 'Baby Baluga',
		artist: 'Raffi Cavoukian',
		barChords: true,
		capo: CAPO_2,
		chords: [CHORD.C, CHORD.G, CHORD.G7, CHORD.F, CHORD.D],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.KIDS],
		link: 'https://tabs.ultimate-guitar.com/r/raffi/baby_beluga_crd.htm',
		lyrics: LYRIC_LIST.BabyBaluga,
	},
	{
		title: 'Baby I Love Your Way',
		artist: 'Peter Frampton',
		barChords: true,
		chords: [
			CHORD.G,
			CHORD.D_OVER_F_SHARP,
			CHORD.E_MINOR,
			CHORD.D,
			CHORD.C,
			CHORD.F9,
			CHORD.E7,
			CHORD.B_MINOR_7,
			CHORD.A_MINOR,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: 'https://tabs.ultimate-guitar.com/p/peter_frampton/baby_i_love_your_way_crd.htm',
		lyrics: LYRIC_LIST.BabyILoveYourWay,
	},
	{
		title: 'Back Home',
		artist: 'Andy Grammer',
		capo: CAPO_4,
		chords: [
			CHORD.G,
			CHORD.C_ADD9,
			CHORD.D,
			CHORD.E_MINOR_7,
			CHORD.A_MINOR,
			CHORD.E_MINOR,
			CHORD.C,
			CHORD.D_OVER_F_SHARP,
		],
		decade: DECADES.TWENTY_TENS,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/andy-grammer/back-home-chords-1479557`,
		lyrics: LYRIC_LIST.BackHome,
	},
	{
		title: "Blowin' in the Wind",
		artist: 'Bob Dylan',
		capo: CAPO_7,
		chords: [CHORD.G, CHORD.C, CHORD.D],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [],
		link: `${UG}/bob-dylan/blowin-in-the-wind-chords-14835`,
		lyrics: LYRIC_LIST.BlowinInTheWind,
	},
	{
		title: 'Butterfly Kisses',
		artist: 'Bob Carlisle',
		barChords: true,
		chords: [CHORD.C, CHORD.F, CHORD.G, CHORD.A_MINOR],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/bob-carlisle/butterfly-kisses-chords-64393`,
		lyrics: LYRIC_LIST.ButterflyKisses,
	},
	// - C -
	{
		title: "Can't Help Falling In Love",
		artist: 'Elvis Presley',
		capo: CAPO_2,
		chords: [
			CHORD.C,
			CHORD.E_MINOR,
			CHORD.A_MINOR,
			CHORD.F,
			CHORD.G,
			CHORD.B7,
			CHORD.A7,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.BALLAD],
		link: `${UG}/elvis-presley/cant-help-falling-in-love-chords-1086983`,
		lyrics: LYRIC_LIST.CantHelpFallingInLove,
	},
	{
		title: 'Closing Time',
		artist: 'Semisonic',
		chords: [
			CHORD.G,
			CHORD.D,
			CHORD.A_MINOR,
			CHORD.C,
			CHORD.B_FLAT,
			CHORD.A_FLAT,
			CHORD.E_FLAT,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/semisonic/closing-time-chords-1743417`,
		lyrics: LYRIC_LIST.ClosingTime,
	},
	{
		title: 'Country Roads',
		artist: 'John Denver',
		capo: CAPO_2,
		chords: [CHORD.G, CHORD.E_MINOR, CHORD.D, CHORD.C, CHORD.F, CHORD.D7],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.COUNTRY],
		link: `${UG}/john-denver/take-me-home-country-roads-chords-1101747`,
		lyrics: LYRIC_LIST.CountryRoads,
	},
	// - D -
	{
		title: "Don't Stop Believin'",
		artist: 'Journey',
		barChords: true,
		chords: [
			CHORD.E,
			CHORD.B,
			CHORD.C_SHARP_MINOR,
			CHORD.A,
			CHORD.G_SHARP_MINOR,
		],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.ROCK],
		link: `${UG}/journey/dont-stop-believin-chords-275297`,
		lyrics: LYRIC_LIST.DontStopBelievin,
	},
	// - F -
	{
		title: 'Forever And Ever Amen',
		artist: 'Randy Travis',
		chords: [CHORD.D, CHORD.G, CHORD.E, CHORD.A, CHORD.B_MINOR],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/randy-travis/forever-and-ever-amen-chords-87134`,
		lyrics: LYRIC_LIST.ForeverAndEverAmen,
		strumPattern: STRUM_PATTERN.TRAVIS_PICKING,
	},
	{
		title: 'Free Fallin',
		artist: 'Tom Petty',
		chords: [CHORD.D, CHORD.D_SUS, CHORD.A_SUS],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: 'https://www.chordie.com/chord.pere/www.guitaretab.com/p/petty-tom/14472.html',
		lyrics: LYRIC_LIST.FreeFallin,
	},
	// - G -
	{
		title: 'Giving Tree',
		artist: "Plain White T's",
		capo: CAPO_1,
		chords: [
			CHORD.E_MINOR,
			CHORD.G,
			CHORD.A_MINOR,
			CHORD.D_OVER_F_SHARP,
			CHORD.D,
			CHORD.C,
			CHORD.B,
			CHORD.G7,
			CHORD.F_SHARP,
			CHORD.D4,
		],
		decade: DECADES.TWENTY_TENS,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/plain-white-ts/the-giving-tree-chords-1240804`,
		lyrics: LYRIC_LIST.GivingTree,
	},
	{
		title: 'God Bless the USA',
		artist: 'Lee Greenwood',
		barChords: true,
		capo: CAPO_3,
		chords: [
			CHORD.D,
			CHORD.A_OVER_D,
			CHORD.G5,
			CHORD.G,
			CHORD.E_MINOR,
			CHORD.C,
			CHORD.A,
			CHORD.F_SHARP_MINOR,
			CHORD.B_MINOR,
			CHORD.D_OVER_F_SHARP,
		],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.PATRIOTIC],
		link: `${UG}/lee-greenwood/god-bless-the-usa-chords-825566`,
		lyrics: LYRIC_LIST.GodBlessTheUSA,
	},
	{
		title: 'Good As You',
		artist: 'Kane Brown',
		capo: CAPO_1,
		chords: [CHORD.G, CHORD.A_MINOR, CHORD.C, CHORD.D],
		decade: DECADES.TWENTY_TENS,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.COUNTRY],
		link: `${UG}/kane-brown/good-as-you-chords-2497455`,
		lyrics: LYRIC_LIST.GoodAsYou,
		// https://tabs.ultimate-guitar.com/tab/kane-brown/good-as-you-chords-2497455
	},
	// - H -
	{
		title: "He's Got the Whole World in His Hands",
		artist: 'Misc Praise',
		chords: [CHORD.C, CHORD.G7],
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.TRADITIONAL, GENRES.SOUL],
		link: 'https://tabs.ultimate-guitar.com/m/misc_praise_songs/hes_got_the_whole_world_in_his_hands_crd.htm',
		lyrics: LYRIC_LIST.HesGotTheWholeWorldInHisHands,
	},
	{
		title: 'Home On The Range',
		artist: 'Misc Traditional',
		chords: [CHORD.G, CHORD.C, CHORD.D],
		decade: DECADES.EIGHTEEN_SEVENTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.WESTERN, GENRES.FOLK],
		link: `${UG}/misc-traditional/home-on-the-range-chords-1726287`,
		lyrics: LYRIC_LIST.HomeOnTheRange,
	},
	{
		title: 'House At Pooh Corner',
		artist: 'Kenny Loggins',
		barChords: true,
		capo: CAPO_5,
		chords: [
			CHORD.C,
			CHORD.D_MINOR,
			CHORD.E_MINOR,
			CHORD.A,
			CHORD.A_MINOR,
			CHORD.F,
			CHORD.G,
			CHORD.G7,
			CHORD.B_FLAT,
		],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.KIDS],
		link: 'https://qcukes.com/music2/music.php?action=Song&song=House%20At%20Pooh%20Corner',
		lyrics: LYRIC_LIST.HouseAtPoohCorner,
		// https://www.youtube.com/watch?v=hWBE9YCC0Oc
	},
	// - I -
	{
		title: 'I Cant Make You Love Me',
		artist: 'Bonnie Raitt',
		capo: CAPO_3,
		chords: [
			CHORD.C,
			CHORD.E_MINOR_9,
			CHORD.G_SUS2_OVER_B,
			CHORD.E_MINOR_7,
			CHORD.A_MINOR_7,
			CHORD.G_OVER_B,
			CHORD.G_OVER_D,
			CHORD.D,
			CHORD.G,
			CHORD.C_MAJ9,
			CHORD.D_OVER_F_SHARP,
			CHORD.G_OVER_C,
			CHORD.F_MAJ9,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/bonnie-raitt/i-cant-make-you-love-me-chords-611294`,
		lyrics: LYRIC_LIST.ICantMakeYouLoveMe,
	},
	{
		title: "I Don't Want To Live On The Moon",
		artist: 'Shawn Colvin',
		barChords: true,
		chords: [
			CHORD.G,
			CHORD.D,
			CHORD.E_MINOR,
			CHORD.C,
			CHORD.D_OVER_F_SHARP,
			CHORD.C_OVER_B,
			CHORD.A_MINOR_7,
			CHORD.B,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.KIDS],
		link: `${UG}/shawn-colvin/i-dont-want-to-live-on-the-moon-chords-3367436`,
		lyrics: LYRIC_LIST.SesameStreetIDontWantToLiveOnTheMoon,
	},
	{
		title: 'I Know An Old Lady Who Swallowed A Fly',
		artist: 'Burl Ives',
		barChords: true,
		chords: [CHORD.D, CHORD.B_MINOR, CHORD.E_MINOR, CHORD.A, CHORD.A7],
		decade: DECADES.FIFTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.KIDS, GENRES.FOLK],
		link:
			UG + '/burl-ives/i-know-an-old-lady-who-swallowed-a-fly-chords-674886',
		lyrics: LYRIC_LIST.IKnowAnOldLadyWhoSwallowedAFly,
	},
	{
		title: "It's Your Love",
		artist: 'Tim McGraw',
		chords: [
			CHORD.G,
			CHORD.D_OVER_F_SHARP,
			CHORD.E_MINOR,
			CHORD.C_ADD9,
			CHORD.F_MINOR,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.COUNTRY],
		link: `${UG}/tim-mcgraw/its-your-love-chords-76292`,
		lyrics: LYRIC_LIST.ItsYourLove,
		strumPattern: STRUM_PATTERN.STANDARD,
		// https://www.youtube.com/watch?v=BOibmAAqWuo
	},
	// - J -
	{
		title: 'Jumper',
		artist: 'Third Eye Blind',
		chords: [CHORD.A_MINOR, CHORD.C, CHORD.G],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [],
		link: `${UG}/third-eye-blind/jumper-chords-159256`,
		lyrics: LYRIC_LIST.Jumper,
	},
	// - K -
	{
		title: 'Killing Me Softly',
		artist: 'Fugees',
		chords: [
			CHORD.E_MINOR,
			CHORD.A_MINOR,
			CHORD.D7,
			CHORD.G,
			CHORD.D,
			CHORD.C,
			CHORD.F_ADD_SHARP_11,
			CHORD.E,
			CHORD.A_MINOR_7,
			CHORD.B7,
			CHORD.F,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.R_AND_B, GENRES.SOUL, GENRES.HIP_HOP],
		link: `${UG}/fugees/killing-me-softly-chords-50470`,
		lyrics: LYRIC_LIST.KillingMeSoftly,
	},
	{
		title: 'Kookaburra',
		artist: 'Marion Sinclair',
		barChords: true,
		chords: [CHORD.C, CHORD.F, CHORD.G7, CHORD.C6],
		decade: DECADES.THIRTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.FOLK, GENRES.KIDS],
		link: `${UG}/marion-sinclair/kookaburra-chords-1048595`,
		lyrics: LYRIC_LIST.Kookaburra,
	},
	{
		title: 'Kumbaya',
		artist: 'Misc Praise',
		chords: [CHORD.C, CHORD.F, CHORD.G],
		decade: DECADES.TWENTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.FOLK, GENRES.SOUL],
		link: `${UG}/misc-praise-songs/kumbaya-chords-76633`,
		lyrics: LYRIC_LIST.Kumbaya,
	},
	// - L -
	{
		title: 'Lean On Me',
		artist: 'Bill Withers',
		barChords: true,
		chords: [CHORD.C, CHORD.F, CHORD.E_MINOR, CHORD.G9, CHORD.G7, CHORD.G],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.R_AND_B, GENRES.SOUL],
		link: `${UG}/bill-withers/lean-on-me-chords-150987`,
		lyrics: LYRIC_LIST.LeanOnMe,
	},
	{
		title: 'Leaving on a Jet Plane',
		artist: 'John Denver',
		chords: [CHORD.A, CHORD.D, CHORD.E],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.ROCK],
		link: 'https://www.laurenbateman.com/leaving-on-a-jet-plane-chord-chart',
		lyrics: LYRIC_LIST.LeavingOnAJetPlane,
	},
	// - M -
	{
		title: 'Maggie May',
		artist: 'Rod Stewart',
		barChords: true,
		chords: [
			CHORD.D,
			CHORD.C,
			CHORD.G,
			CHORD.A_MINOR,
			CHORD.B_MINOR,
			CHORD.A_MINOR_7,
			CHORD.C7,
		],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.ROCK, GENRES.FOLK],
		link: `${UG}/rod-stewart/maggie-may-chords-85329`,
		lyrics: LYRIC_LIST.MaggieMay,
	},
	{
		title: 'Make You Feel My Love',
		artist: 'Adele',
		capo: CAPO_3,
		chords: [
			CHORD.G,
			CHORD.D,
			CHORD.F,
			CHORD.C,
			CHORD.C_MINOR,
			CHORD.A7,
			CHORD.D7,
			CHORD.B7,
			CHORD.A_MINOR_7,
		],
		decade: DECADES.TWO_THOUSANDS,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/adele/make-you-feel-my-love-chords-752102`,
		lyrics: LYRIC_LIST.MakeYouFeelMyLove,
		strumPattern: STRUM_PATTERN.ROCK,
	},
	{
		title: 'Michael Finnegan',
		artist: 'Misc Traditional',
		chords: [CHORD.C, CHORD.G],
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.TRADITIONAL, GENRES.KIDS],
		link: `${UG}/misc-children/michael-finnegan-chords-1721165`,
		lyrics: LYRIC_LIST.MichaelFinnegan,
	},
	{
		title: 'Michael Row the Boat Ashore',
		artist: 'Misc Traditional',
		barChords: true,
		chords: [CHORD.C, CHORD.F, CHORD.E_MINOR, CHORD.G],
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.TRADITIONAL],
		link: `${UG}/highwaymen/michael-row-the-boat-ashore-chords-1813491`,
		lyrics: LYRIC_LIST.MichaelRowTheBoatAshore,
	},
	{
		title: 'Hush Little Baby',
		artist: 'Misc Traditional',
		chords: [CHORD.D, CHORD.A],
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.TRADITIONAL],
		link: 'https://tabs.ultimate-guitar.com/m/mother_goose/hush_little_baby_crd.htm',
		lyrics: LYRIC_LIST.Mockingbird,
	},
	{
		title: 'My Bonnie Lies Over The Ocean',
		artist: 'Misc Traditional',
		chords: [CHORD.D, CHORD.G, CHORD.A, CHORD.A7, CHORD.E_MINOR, CHORD.E7],
		decade: DECADES.EIGHTEEN_EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.FOLK],
		link: `${UG}/misc-traditional/my-bonnie-lies-over-the-ocean-chords-973976`,
		lyrics: LYRIC_LIST.MyBonnieLiesOverTheOcean,
	},
	// - N -
	{
		title: 'Night Changes',
		artist: 'One Direction',
		barChords: true,
		capo: CAPO_1,
		chords: [
			CHORD.G,
			CHORD.E_MINOR_7,
			CHORD.B_MINOR,
			CHORD.D,
			CHORD.C,
			CHORD.D_OVER_F_SHARP,
			CHORD.E_MINOR,
			CHORD.A,
			CHORD.F_SHARP_MINOR,
			CHORD.E,
			CHORD.C_SHARP_MINOR,
			CHORD.E_OVER_G_SHARP,
		],
		decade: DECADES.TWENTY_TENS,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/one-direction/night-changes-chords-1678440`,
		lyrics: LYRIC_LIST.NightChanges,
	},
	// - O -
	{
		title: 'Oh Susanna',
		artist: 'Misc Traditional',
		chords: [CHORD.A, CHORD.E, CHORD.D],
		decade: DECADES.EIGHTEEN_FOURTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.FOLK],
		link: `${UG}/misc-traditional/oh-susanna-chords-1050965`,
		lyrics: LYRIC_LIST.OhSusanna,
	},
	{
		title: 'On Top Of Spaghetti',
		artist: 'Misc Children',
		chords: [CHORD.C, CHORD.G, CHORD.D],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.KIDS, GENRES.FOLK],
		link: `${UG}/misc-children/on-top-of-spaghetti-chords-1404074`,
		lyrics: LYRIC_LIST.OnTopOfSpaghetti,
	},
	{
		title: 'One Tin Soldier',
		artist: 'The Original Caste',
		barChords: true,
		chords: [
			CHORD.C,
			CHORD.G,
			CHORD.A_MINOR,
			CHORD.E_MINOR,
			CHORD.F,
			CHORD.D_FLAT,
			CHORD.A_FLAT,
			CHORD.B_FLAT_MINOR,
			CHORD.F_MINOR,
			CHORD.G_FLAT,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: `${UG}/the-original-caste/one-tin-soldier-chords-980986`,
		lyrics: LYRIC_LIST.OneTinSoldier,
	},
	{
		title: 'Over the Rainbow',
		artist: "Israel Kamakawiwo'ole",
		barChords: true,
		capo: CAPO_5,
		chords: [
			CHORD.G_OVER_D,
			CHORD.D,
			CHORD.E_MINOR,
			CHORD.C_OVER_E,
			CHORD.C,
			CHORD.G,
			CHORD.B_MINOR,
			CHORD.B7,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/2135261`,
		lyrics: LYRIC_LIST.OverTheRainbow,
	},
	// - P -
	{
		title: 'Puff The Magic Dragon',
		artist: 'Peter, Paul & Mary',
		barChords: true,
		capo: CAPO_2,
		chords: [
			CHORD.G,
			CHORD.B_MINOR,
			CHORD.C,
			CHORD.E_MINOR,
			CHORD.A7,
			CHORD.D,
			CHORD.D7,
			CHORD.A,
			CHORD.C_SHARP_MINOR,
			CHORD.F_SHARP_MINOR,
			CHORD.B7,
			CHORD.E,
			CHORD.E7,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.FOLK, GENRES.KIDS],
		link: 'https://tabs.ultimate-guitar.com/p/peter_paul_and_mary/puff_the_magic_dragon_ver3_crd.htm',
		lyrics: LYRIC_LIST.PuffTheMagicDragon,
	},
	// - R -
	{
		title: 'Rainbow Connection',
		artist: 'Kenny Loggins',
		capo: CAPO_2,
		chords: [
			CHORD.G,
			CHORD.E_MINOR,
			CHORD.C,
			CHORD.D,
			CHORD.C_MAJ7,
			CHORD.B_MINOR_7,
			CHORD.A_MINOR_7,
			CHORD.B_MINOR,
			CHORD.E,
		],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.KIDS],
		link: `${UG}/kenny-loggins/rainbow-connection-chords-22350`,
		lyrics: LYRIC_LIST.RainbowConnection,
	},
	{
		title: 'Right Here Waiting',
		artist: 'Richard Marx',
		barChords: true,
		chords: [
			CHORD.E,
			CHORD.A,
			CHORD.D,
			CHORD.G,
			CHORD.B,
			CHORD.C,
			CHORD.A_MINOR,
			CHORD.F,
			CHORD.D_MINOR,
			CHORD.D_MINOR_7,
		],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/richard-marx/right-here-waiting-chords-93388`,
		lyrics: LYRIC_LIST.RightHereWaiting,
	},
	// - S -
	{
		title: "She'll Be Coming Round The Mountain",
		artist: 'Misc Traditional',
		chords: [CHORD.G, CHORD.D7, CHORD.C],
		decade: DECADES.TWENTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.KIDS, GENRES.FOLK],
		link:
			UG +
			'/misc-traditional/shell-be-coming-round-the-mountain-chords-1178525',
		lyrics: LYRIC_LIST.ShellBeComingRoundTheMountain,
	},
	{
		title: 'Sittin On The Dock Of The Bay',
		artist: 'Otis Redding',
		chords: [
			CHORD.G,
			CHORD.B,
			CHORD.C,
			CHORD.B_FLAT,
			CHORD.A,
			CHORD.E,
			CHORD.D,
			CHORD.F,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.R_AND_B],
		link: `${UG}/otis-redding/sittin-on-the-dock-of-the-bay-chords-81840`,
		lyrics: LYRIC_LIST.SittinOnTheDockOfTheBay,
	},
	{
		title: 'Stand By Me',
		artist: 'Ben E. King',
		barChords: true,
		chords: [CHORD.A, CHORD.F_SHARP_MINOR, CHORD.D, CHORD.E],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.R_AND_B, GENRES.SOUL],
		link: `${UG}/ben-e-king/stand-by-me-chords-73005`,
		lyrics: LYRIC_LIST.StandByMe,
	},
	{
		title: 'Sunshine',
		artist: 'Jonathan Edwards',
		capo: CAPO_1,
		chords: [CHORD.A, CHORD.E, CHORD.D, CHORD.G],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [],
		link: `${UG}/jonathan-edwards/sunshine-chords-105167`,
		lyrics: LYRIC_LIST.Sunshine,
	},
	// - T -
	{
		title: 'Take It Easy',
		artist: 'Eagles',
		chords: [
			CHORD.G,
			CHORD.C_OVER_G,
			CHORD.A_MINOR_OVER_G,
			CHORD.D,
			CHORD.C,
			CHORD.E_MINOR,
			CHORD.A_MINOR,
			CHORD.A_MINOR_7,
			CHORD.D_MINOR_7_OVER_G,
			CHORD.G9,
			CHORD.D7,
		],
		decade: DECADES.SEVENTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [GENRES.ROCK],
		link: `${UG}/eagles/take-it-easy-chords-14303`,
		lyrics: LYRIC_LIST.TakeItEasy,
	},
	{
		title: 'Tears In Heaven',
		artist: 'Eric Clapton',
		barChords: true,
		chords: [CHORD.G, CHORD.E_MINOR, CHORD.C, CHORD.D],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.R_AND_B],
		link: 'https://www.guitartabsexplorer.com/clapton-eric-Tabs/tears-in-heaven-live-crd.php',
		lyrics: LYRIC_LIST.TearsInHeaven,
		strumPattern: STRUM_PATTERN.SIXTEENTH,
	},
	// {
	// 	artist: 'Harry S Miller',
	// 	genres: [GENRES.KIDS],
	// 	link: 'https://tabs.ultimate-guitar.com/h/harry_s_miller/the_cat_came_back_crd.htm',
	// 	lyrics: LYRIC_LIST.TheCatCameBack,
	// 	title: 'The Cat Came Back',
	// },
	{
		title: 'The Sounds of Silence',
		artist: 'Simon & Garfunkel',
		barChords: true,
		chords: [CHORD.F_SHARP_MINOR, CHORD.E, CHORD.D, CHORD.A, CHORD.C],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.FOLK],
		link: 'https://tabs.ultimate-guitar.com/s/simon_garfunkel/the_sound_of_silence_ver4_crd.htm',
		lyrics: LYRIC_LIST.TheSoundOfSilence,
	},
	{
		title: 'This Land is your Land',
		artist: 'Woody Guthrie',
		chords: [CHORD.G, CHORD.C, CHORD.D, CHORD.G7, CHORD.D7],
		decade: DECADES.FOURTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.PATRIOTIC],
		link: 'http://www.guitaretab.com/w/woody-guthrie/223617.html',
		lyrics: LYRIC_LIST.ThisLandIsYourLand,
	},
	{
		title: 'Tie Me Kangaroo Down Sport',
		artist: 'Rolf Harris',
		capo: CAPO_3,
		chords: [CHORD.D, CHORD.D7, CHORD.G, CHORD.E_MINOR, CHORD.A, CHORD.A7],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.KIDS],
		link: 'https://tabs.ultimate-guitar.com/r/rolf_harris/tie_me_kangaroo_down_sport_ver4_crd.htm',
		lyrics: LYRIC_LIST.TieMeKangarooDownSport,
	},
	{
		title: 'Turn" Turn" Turn',
		artist: 'The Byrds',
		barChords: true,
		chords: [
			CHORD.D,
			CHORD.G,
			CHORD.F_SHARP_MINOR,
			CHORD.A,
			CHORD.D_SUS4,
			CHORD.E_MINOR,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.FOLK],
		link:
			UG +
			'/the-byrds/turn-turn-turn-to-everything-there-is-a-season-chords-1055233',
		lyrics: LYRIC_LIST.TurnTurnTurn,
	},
	// - W -
	{
		title: 'Walking On Sunshine',
		artist: 'Katrina and the Waves',
		capo: CAPO_1,
		chords: [CHORD.A, CHORD.D, CHORD.E],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [],
		link: `${UG}/katrina-and-the-waves/walking-on-sunshine-chords-595283`,
		lyrics: LYRIC_LIST.WalkingOnSunshine,
	},
	{
		title: 'What the World Needs Now is Love',
		artist: 'Jackie DeShannon',
		barChords: true,
		capo: CAPO_1,
		chords: [
			CHORD.E_MINOR,
			CHORD.A_MINOR,
			CHORD.D_MINOR_7,
			CHORD.G,
			CHORD.E7,
			CHORD.G7,
			CHORD.B_FLAT,
			CHORD.D_MINOR,
			CHORD.D7,
			CHORD.F_MINOR,
			CHORD.B_FLAT_MINOR,
			CHORD.F_SHARP,
			CHORD.G6,
			CHORD.G_SHARP,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.INTERMEDIATE,
		genres: [],
		link: 'https://tabs.ultimate-guitar.com/j/jackie_deshannon/what_the_world_needs_now_is_love_crd.htm',
		lyrics: LYRIC_LIST.WhatTheWorldNeedsNowIsLove,
	},
	{
		title: 'Where Have All the Flowers Gone',
		artist: 'Pete Seeger',
		barChords: true,
		capo: CAPO_5,
		chords: [
			CHORD.C,
			CHORD.A_MINOR,
			CHORD.D_MINOR_7,
			CHORD.G,
			CHORD.G7,
			CHORD.F,
			CHORD.D_MINOR,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [GENRES.FOLK],
		link: 'https://tabs.ultimate-guitar.com/p/peter_paul_and_mary/where_have_all_the_flowers_gone_ver2_crd.htm',
		lyrics: LYRIC_LIST.WhereHaveAllTheFlowersGone,
	},
	{
		title: 'With Or Without You',
		artist: 'U2',
		barChords: true,
		chords: [CHORD.D, CHORD.A, CHORD.B_MINOR, CHORD.G],
		decade: DECADES.EIGHTIES,
		difficulty: DIFFICULTY.BEGINNER,
		genres: [],
		link: `${UG}/u2/with-or-without-you-chords-835`,
		lyrics: LYRIC_LIST.WithOrWithoutYou,
	},
	// - Y -
	{
		title: 'Yellow Submarine',
		artist: 'The Beatles',
		chords: [
			CHORD.E,
			CHORD.D,
			CHORD.B,
			CHORD.A,
			CHORD.C,
			CHORD.A_MINOR,
			CHORD.F_SHARP_MINOR,
		],
		decade: DECADES.SIXTIES,
		difficulty: DIFFICULTY.ADVANCED,
		genres: [],
		link: 'https://tabs.ultimate-guitar.com/t/the_beatles/yellow_submarine_ver2_crd.htm',
		lyrics: LYRIC_LIST.YellowSubmarine,
	},
	{
		title: 'You Are My Sunshine',
		artist: 'Chris Stapleton',
		chords: [CHORD.D, CHORD.G, CHORD.A],
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [GENRES.TRADITIONAL],
		link: `${UG}/morgane-stapleton/you-are-my-sunshine-chords-1843946`,
		lyrics: LYRIC_LIST.YouAreMySunshine,
	},
	{
		title: "You're Still The One",
		artist: 'Shania Twain',
		capo: CAPO_1,
		chords: [CHORD.D, CHORD.G, CHORD.A, CHORD.E_MINOR],
		decade: DECADES.NINETIES,
		difficulty: DIFFICULTY.ABSOLUTE_BEGINNER,
		genres: [],
		link: `${UG}/shania-twain/youre-still-the-one-chords-1345`,
		lyrics: LYRIC_LIST.YoureStillTheOne,
	},
];
